import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Ellipse from '@bubble-ui/primitive-ellipse';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationRawMaterialExtraction = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationRawMaterialExtraction',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1DA399",
    d: "M45.098 76h9.804v19.098a4.902 4.902 0 1 1-9.804 0V76Z"
  }), /*#__PURE__*/React.createElement(Ellipse, {
    cx: 20.588,
    cy: 47,
    fill: "url(#paint0_linear_5601_1342)",
    rx: 20.588,
    ry: 21
  }), /*#__PURE__*/React.createElement(Ellipse, {
    cx: 79.412,
    cy: 47,
    fill: "url(#paint1_linear_5601_1342)",
    rx: 20.588,
    ry: 21
  }), /*#__PURE__*/React.createElement(Ellipse, {
    cx: 50,
    cy: 25,
    fill: "url(#paint2_linear_5601_1342)",
    rx: 24.51,
    ry: 25
  }), /*#__PURE__*/React.createElement(Ellipse, {
    cx: 50,
    cy: 47,
    fill: "url(#paint3_linear_5601_1342)",
    rx: 24.51,
    ry: 25
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_linear_5601_1342)",
    d: "M17.232 67.623c9.666-5.19 17.261-6.591 22.048-4.047 4.83 2.568 5.932 8.682 6.181 11.191l.06.6-.345.488c-1.444 2.046-5.39 6.778-10.83 6.534-5.391-.241-11.282-5.334-17.113-14.767v.001Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint5_linear_5601_1342)",
    d: "M82.767 67.623c-9.665-5.19-17.26-6.591-22.047-4.047-4.831 2.568-5.932 8.682-6.181 11.191l-.06.6.345.488c1.444 2.046 5.39 6.778 10.83 6.534 5.39-.241 11.282-5.334 17.113-14.767v.001Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint6_linear_5601_1342)",
    d: "M47.226 46.556c1.24-2.018 4.005-2.018 5.245 0 5.55 9.038 7.929 23.455 6.91 28.154-1.177 5.431-6.673 8.1-8.981 8.996l-.551.214-.551-.214c-2.308-.895-7.803-3.565-8.981-8.996-1.019-4.7 1.36-19.115 6.91-28.154Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1342",
    x1: 20.588,
    x2: 20.588,
    y1: 26,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#EBD4FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#9396FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_5601_1342",
    x1: 79.412,
    x2: 79.412,
    y1: 26,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#EBD4FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#9396FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_5601_1342",
    x1: 50,
    x2: 50,
    y1: 9,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#EBD4FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#9396FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_5601_1342",
    x1: 50,
    x2: 50,
    y1: 31,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#EBD4FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#9396FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_5601_1342",
    x1: 17.232,
    x2: 45.6,
    y1: 67.623,
    y2: 75.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#01EEB7"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#1DA399"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint5_linear_5601_1342",
    x1: 82.767,
    x2: 54.399,
    y1: 67.623,
    y2: 75.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#01EEB7"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#1DA399"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint6_linear_5601_1342",
    x1: 49.849,
    x2: 49.849,
    y1: 54,
    y2: 83.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#00EDB6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2AB9B3"
  }))));
};
ColoredIllustrationRawMaterialExtraction.displayName = 'ColoredIllustrationRawMaterialExtraction';
export default withProvisionalOverrideFromContext(ColoredIllustrationRawMaterialExtraction);
//# sourceMappingURL=index.js.map